import { ComponentType, createElement } from 'react';
import { createRoot } from 'react-dom/client';

import { IMAGE_FACTOR, PNG_HEIGHT, PNG_WIDTH } from './constants.ts';
import { svgToPng } from './svgToPng.ts';

export const pngChartMaker = async <T extends object>(
  element: ComponentType<T>,
  props: T,
): Promise<string | undefined> => {
  const tmp = document.createElement('div');
  tmp.style.width = `${PNG_WIDTH * IMAGE_FACTOR}px`;
  tmp.style.height = `${PNG_HEIGHT * IMAGE_FACTOR}px`;
  tmp.style.position = 'absolute';
  tmp.style.left = '-9999px';
  document.body.appendChild(tmp);

  const root = createRoot(tmp);
  root.render(createElement(element, props));

  await new Promise((resolve) => {
    setTimeout(resolve, 50);
  });

  const svg = tmp.querySelector<SVGSVGElement>('.recharts-surface');

  if (!svg) {
    root.unmount();
    document.body.removeChild(tmp);
    return undefined;
  }

  const pngData = await svgToPng(svg, PNG_WIDTH * IMAGE_FACTOR, PNG_HEIGHT * IMAGE_FACTOR);

  root.unmount();
  document.body.removeChild(tmp);
  return pngData;
};
